import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Policies.css";

const PrivacyPolicyPage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <p className="hn-policies-updated">Last Updated: 2026-03-12</p>
        <h1 className="hn-policies-title">Privacy Policy</h1>
        <div className="hn-policies-body">
          <p>
            Hosting Noodle respects user privacy and is committed to protecting personal information.
          </p>
          <p>
            We may collect information such as name, email address, IP address, account information, and payment-related details necessary to provide our services.
          </p>
          <p>
            Information collected may be used to operate and improve services, manage accounts, provide customer support, process transactions, and ensure platform security.
          </p>
          <p>
            Hosting Noodle may share necessary information with third-party service providers, infrastructure partners, payment processors, or support providers when required to deliver services or comply with legal obligations.
          </p>
          <p>
            We may also disclose information if required by law, regulation, legal process, or governmental request.
          </p>
          <p>
            Hosting Noodle does not sell personal data to third parties.
          </p>
          <p>
            Users are responsible for protecting their account credentials and ensuring their account security.
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default PrivacyPolicyPage;
